import { useState } from 'react';
import c from 'classnames';

import { ProcessedBacteriaData } from 'services/seeding/seedingResponses';

import { Icon } from '@repo/ui';
import styles from '../Bacterium/Bacterium.module.scss';
import { AnimatePresence, motion } from 'framer-motion';

function detailsPresent(_bacterium: ProcessedBacteriaData) {
  // Seeding bacteria typically only have about info, no associations
  // You could add associations logic here if the seeding endpoint is updated to include them
  return false;
}

type SeedingBacteriumProps = {
  bacterium: ProcessedBacteriaData;
  transferredFromBirthMother?: boolean;
};

export const SeedingBacterium = ({
  bacterium,
  transferredFromBirthMother = false,
}: SeedingBacteriumProps) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <>
      <div
        id={bacterium.id}
        className={c(
          styles.row,
          detailsPresent(bacterium) && styles.hoverable,
          detailsPresent(bacterium) && 'hoverable',
          styles[bacterium.category ?? 'Unknown'],
        )}
        onClick={() => setIsOpen(!isOpen)}
        role={detailsPresent(bacterium) ? 'button' : 'listitem'}
      >
        <div className={styles.taxonomyName}>{bacterium.taxonomy_name}</div>
        <div className={styles.bacteriaDetails}>
          <div className={c('font-S', styles.bacteriaAbundance)}>
            {(bacterium.classified_relative_abundance
              ? bacterium.classified_relative_abundance * 100
              : 0
            ).toFixed(3)}
            %
          </div>

          <Icon
            name='circleFilled'
            size='s'
            className={c(
              'my-auto',
              styles.bacteriaCircle,
              styles[bacterium.category ?? ''] ?? styles.Unknown,
            )}
          />
          {!!transferredFromBirthMother && (
            // content is coming from css
            <div
              className={`ps-1 sharedTaxaSymbol present-in-${bacterium.shared}`}
            />
          )}

          {detailsPresent(bacterium) ? (
            <Icon
              name='chevronDown'
              size='s'
              data-testid='chevron'
              className={c(
                'my-auto',
                styles.rotate,
                isOpen ? styles.iconRotateUp : styles.iconRotateDown,
              )}
            />
          ) : (
            <div className={styles.spacer} />
          )}
        </div>
      </div>

      <AnimatePresence>
        {detailsPresent(bacterium) && isOpen && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            transition={{ duration: 0.6 }}
            className={styles.collapse}
          >
            <div className={c(styles.bacteriaDetail, 'text-start')}>
              {/* Add any seeding-specific content here */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};